
import { notification } from "antd";
import MainServices from "./Main.services";
import getState, { createPromise, dynamicSort, formatNumber, generateGUID, isArray, toTitleCase } from "../utils/MainHelper";
import { fGetBehaviorMatchAndColor, fRenderShare, getAllKeywordsInFolder, getCountryCode, getCountryFinalCut, getCountryHardCodePackage, getCountryIndexSize, getCountryLimit, getMarketPackage, getMarketPackageCode, getMasterSize, getModuleCode, getPackage, getPackageObj, getServer, parseReportData } from "../utils/oneintelligence/OneIntelligenceHelper";
import { setMasterSize } from "../store/components/Reports.slice";
import OneIntelligenceServices from "./OneIntelligence.services";
import store from "../store/store";
import WorkerServices from "./Worker.services";
import { setAudienceSizeListObj } from "../store/components/SSPAudience.slice";
import TrackFeatureServices from "./TrackFeature.services";

class ReportsServices {
    constructor() {
        this.cls = process.env.REACT_APP_OI_API_CLASS || "oneintel";
    }

    getMasters(dontAddParent, givenBuildedTargets) {
        const { buildedTargets } = getState("marketExplorer").configuration;
        const mastersObj = [];
        (givenBuildedTargets || buildedTargets).forEach((orItem) => {
            mastersObj.push(orItem.groups.reduce((acc, bigAnd) => {
                bigAnd.targets.forEach((item) => {
                    const keyword = item.name.toLocaleLowerCase();
                    const key = (() => {
                        // if (item.namePath) return `${item.namePath.replace("/", " - ")}***`;
                        if (item.namePath) return `${item.namePath.split("/").pop()}`;
                        return item.name;
                    })();
                    acc[key] = [];
                    if (!dontAddParent) {
                        acc[key].push(keyword);
                    }
                    getAllKeywordsInFolder(item.children || item.tempChildren).forEach((child) => {
                        if (!acc[key].includes(child)) {
                            acc[key].push(child);
                        }
                    });
                });
                return acc;
            }, {}));
        });
        return mastersObj[0];
    }

    getMastersTargetAudience() {
        const { buildedTargets } = getState("marketExplorer").configuration;
        const marketPackageCode = getMarketPackageCode();
        const moduleCode = getModuleCode();
        const getMaster = () => {
            const mastersObj = [];
            buildedTargets.forEach((orItem) => {
                mastersObj.push(orItem.groups.reduce((acc, bigAnd) => {
                    bigAnd.targets.forEach((item) => {
                        const keyword = (() => {
                            if ((["aitag"].includes(marketPackageCode)
                                || ["facebookaudiences"].includes(moduleCode)) && item.namePath) return item.namePath.replace("/", " - ");
                            return item.name;
                        })();
                        acc[keyword] = [];
                    });
                    return acc;
                }, {}));
            });
            return mastersObj[0];
        };
        const masters = Object.keys(getMaster());
        return masters.reduce((acc, key, idx) => {
            acc += key;
            if (masters[idx + 1]) { acc += " | "; }
            return acc;
        }, "");
    }

    getUsigDashboard(monitorObj) {
        const allPromises = [];
        const { server } = getServer();
        const masters = this.getMasters(true);
        const countryIndexSize = getCountryIndexSize();
        const countryfinalCut = getCountryFinalCut();
        const packageValue = getCountryHardCodePackage() || getPackage();

        const requestBody = {
            dashboardMode: true,
            finalCut: 0.01,
            limit: getCountryLimit(),
            masterOrSelection: packageValue,
            marketPackage: getMarketPackage(),
            region: getCountryCode("savant"),
            semCountry: getCountryCode(2),
            package: packageValue,
            masters,
            selections: {},
            server,
            useAudienceSize: true,
            useWordTranslation: false
        };
        if (countryIndexSize !== undefined) {
            requestBody.indexSize = countryIndexSize;
        }
        if (countryfinalCut !== undefined) {
            requestBody.finalCut = countryfinalCut;
        }
        const promiseObj = this.getUsigDashboardPerItem(requestBody, monitorObj);
        allPromises.push(promiseObj);

        return {
            promise: promiseObj.promise.then(async (res) => {
                let parsed = [];
                if (res) {
                    parsed = await parseReportData(res, requestBody.selections);
                }
                return parsed;
            }),
            stopPolling: () => {
                allPromises.forEach((prm) => {
                    if (prm.stopPolling) prm.stopPolling();
                });
            }
        };
    }

    getUsigDashboardPerItem(requestBody, monitorObj) {
        const options = {
            gateway: {
                class: this.cls,
                function: "getusigdashboard"
            }
        };
        const { startMonitor, endMonitor, getNewRequestResponse } = TrackFeatureServices.getMonitor()
        const newRequestResponse = getNewRequestResponse();
        const toMonitorParams = {
            ...monitorObj,
            ...newRequestResponse,
        }
        const monitorCallBack = (sqsUrl, request) => {
            toMonitorParams.url = sqsUrl + "/getusigdashboard"
            startMonitor(request, toMonitorParams);
        }
        return MainServices.smartApiCall(options, requestBody, () => { }, monitorCallBack).promise.then((res) => {
            endMonitor(res, toMonitorParams)
            return res
        })
    }

    getSSPGetAudienceSize(monitorObj) {
        const { dispatch } = store;
        const masters = this.getMasters();
        const { server } = getServer();
        const region = getCountryCode("savant");
        const options = {
            gateway: {
                class: this.cls,
                function: "sspgetaudiencesize"
            }
        };

        const freeFormMaster = {};
        const folderMasters = {};

        Object.keys(masters).forEach((key) => {
            if (masters[key].length > 1 || key.includes("*")) {
                const [parent] = key.split(" - ")
                if (!folderMasters[parent]) folderMasters[parent] = {}
                folderMasters[parent][key] = masters[key]
            } else {
                freeFormMaster[key] = masters[key];
            }
        });
        const getSSPAudienceSize = (requestBody) => {
            const { startMonitor, endMonitor, getNewRequestResponse } = TrackFeatureServices.getMonitor()
            const url = MainServices.url + "oneintel/" + options.gateway.function.toLocaleLowerCase()
            const newRequestResponse = getNewRequestResponse();
            const toMonitorParams = {
                ...monitorObj,
                ...newRequestResponse,
                url
            }
            startMonitor(requestBody, toMonitorParams)
            // return MainServices.savantApiCall(
            //     options.gateway.function,
            //     {
            //         ...requestBody,
            //         _class: "oneintel",
            //         _function: "sspgetaudiencesize",
            //     },
            //     options,
            //     server,
            //     url
            // ).promise.then((resp) => {
            //     endMonitor(resp, toMonitorParams)
            //     return resp
            // })
            return MainServices.smartApiCall(
                options,
                {
                    ...requestBody,
                    _class: "oneintel",
                    _function: "sspgetaudiencesize",
                }
            ).promise.then((resp) => {
                endMonitor(resp, toMonitorParams)
                return resp
            })
        };

        const promises = [];
        if (Object.keys(freeFormMaster).length) {
            const audienceItems = Object.values(freeFormMaster).reduce((acc, item) => {
                acc = acc.concat(item.map((text) => {
                    const newItems = text.split(" ").join(" ")
                    return newItems
                }));
                return acc;
            }, []);

            if (audienceItems.length === 1) audienceItems.push("the heck");

            promises.push(getSSPAudienceSize({
                region,
                type: "keyword",
                items: audienceItems,
                server
            }).then((resp) => {
                const { data } = resp || {};
                if (!data) { return 0; }
                const tempmastersValue = {};
                Object.keys(data).forEach((key) => {
                    const value = data[key];
                    const foundMaster = Object.keys(freeFormMaster).find((masterKey) => {
                        if (masters[masterKey].includes(key)) return masterKey;
                    });
                    if (foundMaster) {
                        if (!tempmastersValue[key]) tempmastersValue[key] = value;
                        else tempmastersValue[key] += value;
                    }
                });
                return Object.keys(tempmastersValue).reduce((sum, key) => {
                    if (!sum) return tempmastersValue[key];
                    return sum += tempmastersValue[key]
                    // return sum *= tempmastersValue[key]
                }, 0);
            }));
        }
        const mastersValue = {};
        if (Object.keys(folderMasters).length) {
            Object.keys(folderMasters).forEach((parentKey) => {
                const folder = folderMasters[parentKey];
                const prms = Promise.all(Object.keys(folder).map((folderName) => {
                    const audienceItems = folder[folderName].map((item) => {
                        const newItems = item.split(" ").join(" ")
                        return newItems;
                    })
                    if (audienceItems.length === 1) audienceItems.push("the heck");
                    return getSSPAudienceSize({
                        region,
                        type: "keyword",
                        items: audienceItems,
                        server
                    }).then((resp) => {
                        const { data } = resp || {};
                        if (!data) { return 0; }
                        const total = Object.keys(data).reduce((sum, key) => {
                            return sum += data[key]
                        }, 0);
                        mastersValue[folderName] = total
                        return total;
                    })
                })).then((totals) => {
                    return totals.reduce((sum, value) => {
                        if (!sum) return value;
                        return sum += value
                        // return sum *= value
                    }, 0);
                })
                promises.push(prms)
            })
            // promises.push(getSSPAudienceSize({
            //     region,
            //     type: "keyword",
            //     items: Object.values(folder).reduce((acc, item) => {
            //         acc = acc.concat(item);
            //         return acc;
            //     }, []),
            //     server
            // }).then((resp) => {
            //     const { data } = resp || {};
            //     if (!data) { return 0; }
            //     const mastersValue = {};
            //     Object.keys(data).forEach((key) => {
            //         const value = data[key];
            //         const foundMaster = Object.keys(folder).find((masterKey) => {
            //             if (folder[masterKey].includes(key)) return masterKey;
            //         });
            //         if (foundMaster) {
            //             if (!mastersValue[foundMaster]) mastersValue[foundMaster] = value;
            //             else mastersValue[foundMaster] += value;
            //         }
            //     });
            //     console.log(mastersValue);
            //     debugger
            //     dispatch(setAudienceSizeListObj(mastersValue))
            //     return Math.min(...Object.values(mastersValue));
            // }));
            // })

        }

        return Promise.all(promises).then((resp) => {
            dispatch(setAudienceSizeListObj(mastersValue))
            dispatch(setMasterSize(Math.min(...resp)));
        });
    }

    getUsigDeepDive(customParams, statusCallBack = () => { }, monitorObj) {
        const { selectedGeneralMarketCategory } = getState("reports");
        const master = selectedGeneralMarketCategory?.name?.toLocaleLowerCase();
        const { server } = getServer();
        const countryIndexSize = getCountryIndexSize();
        const countryfinalCut = getCountryFinalCut();
        const packageValue = getCountryHardCodePackage() || getPackage();

        let requestBody = {
            country: getCountryCode(2),
            enterpriseCode: getCountryCode("enterprise"),
            package: packageValue,
            marketPackage: getMarketPackage(),
            masterOrSelection: packageValue,
            masters: { [master]: [master] },
            region: getCountryCode("savant"),
            server,
            limit: getCountryLimit(),
            useAudienceSize: true,
            useWordTranslation: false
        };

        if (countryIndexSize !== undefined) {
            requestBody.indexSize = countryIndexSize;
        }
        if (countryfinalCut !== undefined) {
            requestBody.finalCut = countryfinalCut;
        }
        if (customParams) {
            requestBody = {
                ...requestBody,
                ...customParams
            };
            if (customParams.lastfolders) {
                requestBody.selections = customParams.lastfolders
            }

            delete requestBody.category
            delete requestBody.masterSize
            delete requestBody.selectionsDetails
            delete requestBody.lastfolders
            delete requestBody.lastObjChecker
        }
        const options = {
            gateway: {
                class: this.cls,
                function: "getusigdeepdive"
            }
        };
        const { startMonitor, endMonitor, getNewRequestResponse } = TrackFeatureServices.getMonitor()
        const newRequestResponse = getNewRequestResponse();
        const toMonitorParams = {
            ...monitorObj,
            ...newRequestResponse,
        }
        const monitorCallBack = (sqsUrl, request) => {
            toMonitorParams.url = sqsUrl + "/getusigdeepdive"
            startMonitor(request, toMonitorParams);
        }
        const { promise, stopPolling } = MainServices.smartApiCall(options, requestBody, statusCallBack, monitorCallBack);
        return {
            promise: promise.then(async (res) => {
                let parsed = [];
                if (res) {
                    if (!res?.data?.items) {
                        console.log("request", requestBody)
                        console.log("response", res)
                    }
                    let finalResponse = res

                    let summary = null

                    if (customParams?.lastObjChecker) {
                        const summaryBehaviorMatch = {};
                        let allFiltered = []

                        finalResponse = {
                            isSuccess: true,
                            message: "DONE",
                            data: {
                                items: Object.keys(customParams.lastObjChecker).reduce((acc, key) => {
                                    const itemChildren = customParams.lastObjChecker[key];

                                    const filteredItems = (res?.data?.items || []).reduce((acc, i) => {
                                        let isIncludes = itemChildren.includes(i.item)
                                        if (!isIncludes && i.item.includes("&")) {
                                            isIncludes = itemChildren.includes(i.item.replace(/&/g, "and"))
                                        }

                                        if (!isIncludes) {
                                            try {
                                                const lastObjTemp = customParams.lastObj[i.item];
                                                if (lastObjTemp) {
                                                    const found = lastObjTemp.find((t) =>
                                                        itemChildren.includes(t)
                                                    );
                                                    isIncludes = found
                                                }
                                            } catch (error) { }
                                        }

                                        if (isIncludes) {
                                            const newObj = {
                                                ...i,
                                                audienceIntersect: i.score * Math.min(parseInt(i.share), customParams.masterSize || getMasterSize()),
                                                ...fGetBehaviorMatchAndColor(i.score),
                                            }
                                            const numberOfitmes = itemChildren.filter((d) => {
                                                let isIncludesSub = d === i.item
                                                if (!isIncludesSub && i.item.includes("&")) {
                                                    isIncludesSub = d === i.item.replace(/&/g, "and")
                                                }
                                                return isIncludesSub
                                            });

                                            const toAdd = numberOfitmes.length

                                            if (!summaryBehaviorMatch[newObj.behaviormatch]) {
                                                summaryBehaviorMatch[newObj.behaviormatch] = {
                                                    count: toAdd,
                                                    behaviormatch: newObj.behaviormatch,
                                                    color: newObj.color,
                                                    bg: newObj.bg
                                                };
                                            } else {
                                                summaryBehaviorMatch[newObj.behaviormatch].count += toAdd;
                                            }
                                            numberOfitmes.forEach(() => {
                                                acc.push(newObj)
                                            })
                                        }
                                        return acc
                                    }, [])

                                    if (filteredItems.length) {
                                        const tempScoreObj = filteredItems.reduce((tempObj, i) => {
                                            tempObj.scoreSum += i.score
                                            tempObj.shareSum += i.share
                                            tempObj.interSectSum += i.audienceIntersect
                                            return tempObj
                                        }, { scoreSum: 0, shareSum: 0, interSectSum: 0 })

                                        const score = tempScoreObj.scoreSum / filteredItems.length;
                                        const share = tempScoreObj.shareSum;

                                        allFiltered = allFiltered.concat(filteredItems)

                                        acc.push({
                                            group: "1",
                                            item: key,
                                            masterSize: 0,
                                            score,
                                            share,
                                            audienceIntersect: tempScoreObj.interSectSum,
                                            topic: filteredItems[0].topic,
                                            wordTranslation: "-"
                                        })
                                    }

                                    return acc
                                }, []).sort(dynamicSort("-score", true))
                            }
                        }

                        summary = {
                            size: fRenderShare(allFiltered),
                            summaryBehaviorMatch
                        }
                    }
                    parsed = await parseReportData(finalResponse, customParams.lastfolders ? customParams.selections : requestBody.selections, customParams.category, customParams.masterSize, customParams.selectionsDetails, summary);
                    parsed = parsed.deepDiveData;
                }
                return parsed;
            }).then((res) => {
                endMonitor(res, toMonitorParams)
                return res
            }),
            stopPolling
        };
    }

    getSubjectsDeepDive(item, statusCallBack = () => { }, monitorObj) {
        const master = item.toLocaleLowerCase();
        const { server } = getServer();

        const countryIndexSize = getCountryIndexSize();
        const countryfinalCut = getCountryFinalCut();
        const packageValue = getCountryHardCodePackage() || getPackage();
        const listSubjectLimit = OneIntelligenceServices.getListSubjectLimit();
        const requestBody = {
            country: getCountryCode(2),
            region: getCountryCode("savant"),
            package: packageValue,
            masterOrSelection: packageValue,
            op: "or",
            items: [master],
            title: master,
            server,
            masters: this.getMasters(true),
            limitDeepDive: getCountryLimit(),
            useAudienceSize: true,
            useWordTranslation: false
        };

        if (countryIndexSize !== undefined) {
            requestBody.indexSize = countryIndexSize;
        }
        if (countryfinalCut !== undefined) {
            requestBody.finalCut = countryfinalCut;
        }
        if (listSubjectLimit !== undefined) {
            requestBody.limitSubjects = listSubjectLimit;
        }

        const options = {
            gateway: {
                class: this.cls,
                function: "getsubjectsdeepdive"
            }
        };

        const { startMonitor, endMonitor, getNewRequestResponse } = TrackFeatureServices.getMonitor()
        const newRequestResponse = getNewRequestResponse();
        const toMonitorParams = {
            ...monitorObj,
            ...newRequestResponse,
        }
        const monitorCallBack = (sqsUrl, request) => {
            toMonitorParams.url = sqsUrl + "/getsubjectsdeepdive"
            startMonitor(request, toMonitorParams);
        }
        const { promise, stopPolling } = MainServices.smartApiCall(options, requestBody, statusCallBack, monitorCallBack);

        return {
            promise: promise.then(async (res) => {
                let parsed = [];
                if (res) {
                    parsed = await parseReportData(res, requestBody.selections);
                    parsed = parsed.deepDiveData;
                }
                return parsed;
            }).then((res) => {
                endMonitor(res, toMonitorParams)
                return res
            }),
            stopPolling
        };
    }

    getQuickReports(monitorObj, waitFunction = () => Promise.resolve()) {
        const { selectedQuickReport } = getState("reports")
        const { server } = getServer();
        const allPromises = [];

        const options = {
            gateway: {
                class: this.cls,
                function: "getquickreports"
            }
        };
        const masters = this.getMasters(true);

        const countryIndexSize = getCountryIndexSize();
        const countryfinalCut = getCountryFinalCut();
        const packageValue = getCountryHardCodePackage() || getPackage();
        const requestBody = {
            name: `${selectedQuickReport.parent.name} - ${selectedQuickReport.name}`,
            region: getCountryCode("savant"),
            package: packageValue,
            country: getCountryCode(2),
            masterOrSelection: packageValue,
            server,
            title: selectedQuickReport.name.toLocaleLowerCase(),
            masters,
            limit: getCountryLimit(),
            useAudienceSize: true,
            useWordTranslation: false
        };

        if (countryIndexSize !== undefined) {
            requestBody.indexSize = countryIndexSize;
        }
        if (countryfinalCut !== undefined) {
            requestBody.finalCut = countryfinalCut;
        }
        const notifObj = {
            message: `${requestBody.name} Generating Report`,
            description: <span style={{ color: "#52c41a" }}>Please wait...</span>,
            duration: null,
            placement: "topRight",
            closable: true,
            // closeIcon: (<div />),
            key: `${requestBody.name}_deepdive-item`
        };
        notification.info(notifObj);
        const statusCallBack = (msg) => {
            notification.info({
                ...notifObj,
                description: <span style={{ color: "#52c41a" }}>{msg}</span>
            });
        };

        return {
            promise: waitFunction().then(() => {
                const { startMonitor, endMonitor, getNewRequestResponse } = TrackFeatureServices.getMonitor()
                const newRequestResponse = getNewRequestResponse();
                const toMonitorParams = {
                    ...monitorObj,
                    ...newRequestResponse,
                }
                const monitorCallBack = (sqsUrl, request) => {
                    toMonitorParams.url = sqsUrl + "/getquickreports"
                    startMonitor(request, toMonitorParams);
                }
                const promiseObj = MainServices.smartApiCall(options, requestBody, statusCallBack, monitorCallBack);
                allPromises.push(promiseObj);
                return promiseObj.promise.then(async (resp) => {
                    if (resp) {
                        const { response, data } = resp;
                        const res = {
                            response: [],
                            data: []
                        };

                        if (response.length) {
                            const reponses = await Promise.all(response.map((d) => parseReportData(d, requestBody.selections)
                                .then((resps) => resps.deepDiveData)));
                            res.response = reponses;
                        } else res.response = response;

                        if (data.length) {
                            const datas = await Promise.all(data.map((d) => parseReportData(d, requestBody.selections)
                                .then((resps) => resps.deepDiveData)));
                            res.data = datas;
                        } else res.data = data;

                        const newItems = [];
                        res.data.forEach((d) => {
                            d.forEach((sd) => { newItems.push(sd); });
                        });
                        res.response.forEach((d) => {
                            d.forEach((sd) => { newItems.push(sd); });
                        });
                        notification.destroy(`${requestBody.name}_deepdive-item`);
                        return newItems.reduce((acc, group, index) => {
                            acc.push({
                                ...group,
                                group: index + 1,
                                children: group.children.map((child) => ({
                                    ...child,
                                    group: index + 1
                                }))
                            });
                            return acc;
                        }, []);
                    }
                    notification.destroy(`${requestBody.name}_deepdive-item`);
                    return resp;
                }).then((resp) => {
                    endMonitor(resp, toMonitorParams);
                    return resp
                })
            }),
            stopPolling: () => {
                allPromises.forEach((prm) => {
                    if (prm.stopPolling) prm.stopPolling();
                });
            }
        };
    }

    getFreeFormExact(
        main,
        initialCallBack = () => { },
        doneApiCallBack = () => { },
        waitFunction = () => Promise.resolve(),
        monitorObj,
        others = {}
    ) {
        const { givenMaster, givenSelections, noNotif } = others
        const { freeForm, categoryDeepDiveData } = getState("reports")

        const lastGroup = categoryDeepDiveData.length ? categoryDeepDiveData[categoryDeepDiveData.length - 1].group : 0;
        let discoveredText = "";
        const freeFormItems = givenSelections || freeForm;
        const selections = freeFormItems.reduce((acc, item, idx) => {
            item = item.toLocaleLowerCase();
            acc[item] = [item];

            discoveredText += item;
            if (freeFormItems[idx + 1]) { discoveredText += " | "; }
            return acc;
        }, {});

        const groupObj = {
            discoveredCategory: toTitleCase(discoveredText),
            group: lastGroup + 1,
            targetAudience: this.getMastersTargetAudience(),
            children: [],
            key: `${generateGUID()}~~deepDiveItem`
        };
        if (!main) groupObj.loading = true;
        initialCallBack([groupObj]);

        const notifObj = {
            message: `${groupObj.discoveredCategory} Generating Report`,
            description: <span style={{ color: "#52c41a" }}>Please wait...</span>,
            duration: null,
            placement: "topRight",
            closable: true,
            // closeIcon: (<div />),
            key: `${groupObj.key}_deepdive-item`
        };

        if (!noNotif) {
            notification.info(notifObj);
        }

        const statusCallBack = (msg) => {
            if (!noNotif) {
                notification.info({
                    ...notifObj,
                    description: <span style={{ color: "#52c41a" }}>{msg}</span>
                });
            }
        };
        let stopPolling = null;
        return {
            promise: waitFunction().then(() => {
                const { promise, stopPolling: stopFunc } = this.getUsigDeepDive({ selections, masters: givenMaster || this.getMasters(true) }, statusCallBack, monitorObj);
                stopPolling = stopFunc;

                return promise.then((response) => {
                    if (response.length) {
                        const [itemToAdd] = response;
                        doneApiCallBack(groupObj, (itemToAdd.children || itemToAdd.tempChildren).map((res) => ({
                            ...res,
                            group: groupObj.group
                        })));
                    } else {
                        // doneApiCallBack(groupObj, []);
                    }
                    notification.destroy(`${groupObj.key}_deepdive-item`);
                });
            }),
            stopPolling
        };
    }

    async getFreeFormNotExact(
        main,
        initialCallBack = () => { },
        doneApiCallBack = () => { },
        waitFunction = () => Promise.resolve(),
        monitorObj
    ) {
        const { freeForm, categoryDeepDiveData } = getState("reports")
        await waitFunction();
        let lastGroup = categoryDeepDiveData.length ? categoryDeepDiveData[categoryDeepDiveData.length - 1].group : 0;
        const newItems = [];
        const prms = freeForm.map((item, idx) => {
            lastGroup += 1;
            const groupObj = {
                discoveredCategory: toTitleCase(item),
                group: lastGroup,
                targetAudience: this.getMastersTargetAudience(),
                children: [],
                key: `${generateGUID()}~~deepDiveItem`
            };
            if (!main) groupObj.loading = true;
            newItems.push(groupObj);
            const notifObj = {
                message: `${groupObj.discoveredCategory} Generating Report`,
                description: <span style={{ color: "#52c41a" }}>Please wait...</span>,
                duration: null,
                placement: "topRight",
                closable: true,
                // closeIcon: (<div />),
                key: `${groupObj.key}_deepdive-item`
            };
            notification.info(notifObj);
            const statusCallBack = (msg) => {
                notification.info({
                    ...notifObj,
                    description: <span style={{ color: "#52c41a" }}>{msg}</span>
                });
            };
            const { promise } = this.getSubjectsDeepDive(item.toLocaleLowerCase(), statusCallBack, monitorObj);
            promise.then((response) => {
                const newGroupObj = { ...groupObj };
                if (main) {
                    // newGroupObj.singleLoad = true;
                }
                if (response.length) {
                    const [itemToAdd] = response;
                    doneApiCallBack(newGroupObj, (itemToAdd.children || itemToAdd.tempChildren).map((res) => ({
                        ...res,
                        group: newGroupObj.group
                    })));
                } else {
                    // doneApiCallBack(newGroupObj, []);
                }
                notification.destroy(`${groupObj.key}_deepdive-item`);
            });
            return promise
        });
        initialCallBack(newItems);

        return Promise.all(prms);
    }

    addBehaviouralSegmentItems(origData, initialCallBack = () => { }, doneApiCallBack = () => { }, monitorObj) {
        const { checkedBehavioralSegments } = getState("reports")

        let newList = [...checkedBehavioralSegments].sort(dynamicSort("lvl", true));
        const checkAllRecursive = (items) => {
            items.forEach((child) => {
                newList = newList.filter((item) => child.name !== item.parent);
                const childList = child.children || child.tempChildren;
                if (childList && childList.length) {
                    checkAllRecursive(childList);
                }
            });
        };

        checkAllRecursive([...newList]);

        const childObjectList = {};
        const selections = {};
        newList.forEach((item) => {
            const childName = item.name.toLocaleLowerCase();
            const childList = item.children || item.tempChildren;
            if (childList && childList.length) {
                childObjectList[childName] = childList;
            }
            selections[childName] = childList ? getAllKeywordsInFolder(childList, []) : [childName];
        });

        initialCallBack({
            ...origData,
            loading: true
        });
        const { promise } = this.getUsigDeepDive({ selections, masters: this.getMasters(true) }, undefined, monitorObj);
        promise.then((response) => {
            if (response.length) {
                const [itemToAdd] = response;
                doneApiCallBack(origData, (itemToAdd.children || itemToAdd.tempChildren).map((res) => {
                    const childName = res.item.toLocaleLowerCase();
                    const newResObj = {
                        ...res,
                        group: origData.group
                    };
                    if (childObjectList[childName]) newResObj.tempChildren = childObjectList[childName];
                    delete newResObj.children;
                    return newResObj;
                }));
            } else {
                // doneApiCallBack(origData, []);
            }
        });
        return promise;
    }

    getMinifiedRequests(allTreeData, main) {
        const { categoryDeepDiveData, checkedBehavioralSegments, allCategoryAnalysisTreeData } = getState("reports")
        const { promise, resolve } = createPromise();

        const toParse = {
            categoryDeepDiveData,
            allCategoryAnalysisTreeData: allTreeData ? allTreeData : allCategoryAnalysisTreeData,
            checkedBehavioralSegments: allTreeData ? allTreeData : checkedBehavioralSegments,
            main,
            targetAudience: this.getMastersTargetAudience()
        };

        WorkerServices.addBehaviouralSegmentFolderParser(toParse).then(async (newItems) => {
            const numberOfCallInSameTime = 5
            const initialApiCall = newItems.length < numberOfCallInSameTime ? 1 : numberOfCallInSameTime;
            let doneCallCount = 0;
            let lastIndex = 0;
        })
    }

    addBehaviouralSegmentFolder(
        allTreeData,
        main,
        initialCallBack = () => { },
        doneApiCallBack = () => { },
        waitFunction = () => Promise.resolve(),
        percentCallback,
        givenBuildedTargets,
        monitorObj
    ) {
        const { categoryDeepDiveData, checkedBehavioralSegments, allCategoryAnalysisTreeData } = getState("reports")
        const { promise, resolve } = createPromise();

        const toParse = {
            categoryDeepDiveData,
            allCategoryAnalysisTreeData: allTreeData ? allTreeData : allCategoryAnalysisTreeData,
            checkedBehavioralSegments: allTreeData ? allTreeData : checkedBehavioralSegments,
            main,
            targetAudience: this.getMastersTargetAudience()
        };

        WorkerServices.addBehaviouralSegmentFolderParser(toParse).then(async (newItems) => {

            const numberOfCallInSameTime = 10
            const initialApiCall = numberOfCallInSameTime;
            // const initialApiCall = newItems.length < numberOfCallInSameTime ? 1 : numberOfCallInSameTime;
            let doneCallCount = 0;
            let lastIndex = 0;
            const prmList = newItems.map(() => createPromise())

            await waitFunction();

            const recurviseApi = (currentIdx) => {
                const item = newItems[currentIdx];
                if (!item) {
                    Promise.all(prmList.map((prm) => prm.promise)).then(() => resolve())
                    return;
                }
                const {
                    info: groupObj,
                    childObjectList,
                    selections,
                    lastfolders,
                    lastObjChecker,
                    selectionsDetails
                } = item;

                const notifObj = {
                    message: `Generating Report for "${groupObj.discoveredCategory}"`,
                    description: <span style={{ color: "#52c41a" }}>{`Loading tile ${currentIdx + 1} of ${newItems.length}`}</span>,
                    duration: null,
                    placement: "topRight",
                    closable: true,
                    // closeIcon: (<div />),
                    key: groupObj.key
                }
                if (!percentCallback) {
                    notification.info(notifObj);
                }
                const statusCallBack = (msg) => {
                    if (!percentCallback) {
                        notification.info({
                            ...notifObj,
                            description: <span style={{ color: "#52c41a" }}>{msg}</span>
                        });
                    }
                };

                this.getUsigDeepDive({
                    selections,
                    masters: this.getMasters(true, givenBuildedTargets),
                    category: { [groupObj.discoveredCategory]: selections },
                    lastfolders,
                    lastObjChecker,
                    selectionsDetails
                }, statusCallBack, monitorObj).promise.then((response) => {
                    doneCallCount += 1
                    notification.destroy(groupObj.key);
                    const newGroupObj = { ...groupObj };
                    if (main) {
                        // newGroupObj.singleLoad = true;
                    }
                    if (response.length) {
                        const [itemToAdd] = response;
                        if (itemToAdd.summary) {
                            newGroupObj.summary = itemToAdd.summary
                        }
                        doneApiCallBack(newGroupObj, (itemToAdd.children || itemToAdd.tempChildren).map((res) => {
                            const childName = res.item.toLocaleLowerCase();
                            const newResObj = {
                                ...res,
                                group: newGroupObj.group
                            };
                            if (childObjectList[childName]) newResObj.tempChildren = childObjectList[childName];
                            delete newResObj.children;
                            return newResObj;
                        }));
                    } else {
                        // doneApiCallBack(newGroupObj, []);
                    }

                    if (percentCallback) {
                        doneCallCount = doneCallCount > newItems.length ? newItems.length : doneCallCount
                        percentCallback({
                            current: doneCallCount,
                            all: newItems.length,
                            percent: doneCallCount / newItems.length
                        })
                    };
                    lastIndex += 1

                    prmList[currentIdx].resolve()
                    recurviseApi(lastIndex);
                });
            };
            initialCallBack(newItems.map((item) => item.info));
            lastIndex = newItems.length < initialApiCall ? newItems.length - 1 : 4
            for (let index = 0; index < initialApiCall; index++) {
                recurviseApi(index);
            }
        });

        return promise;
    }
}

export default new ReportsServices();
